import { useTranslation } from '@shared/core';
import { ButtonV2Props } from '@withjoy/joykit';
import React, { useMemo } from 'react';
import { StyledEventBackButton, StyledEventFormButton } from '../styles';

type NavigationButtonProps = ButtonV2Props & {
  direction: 'next' | 'prev' | 'done';
  text?: string;
};

export const NavigationButton = (props: NavigationButtonProps) => {
  const { text, direction } = props;
  const { tq } = useTranslation('eventFormDisplay');

  const label = useMemo(() => {
    switch (direction) {
      case 'next':
        return tq`Next`;
      case 'prev':
        return tq`Back`;
      case 'done':
        return tq`Submit`;
    }
  }, [direction, tq]);

  if (direction === 'prev') {
    return (
      <StyledEventBackButton
        intent="newPrimary"
        variant="outline"
        shape="rounded"
        width="100%"
        {...props}
      >
        {text ?? label}
      </StyledEventBackButton>
    );
  }

  return (
    <StyledEventFormButton
      intent="newPrimary"
      variant="solid"
      shape="rounded"
      width="100%"
      {...props}
    >
      {text ?? label}
    </StyledEventFormButton>
  );
};
